import React, { useState } from 'react';
import Grid from "@mui/material/Grid";
import SimpleReactValidator from "simple-react-validator";
import { toast } from "react-toastify";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { Link, useNavigate, useParams  } from "react-router-dom";
import authService from '../../services/authService';
import LoadingOverlay from '../../components/loading/loading';

const ChangePassword = (props) => {

    const push = useNavigate()
    const { id, token } = useParams();

    const [value, setValue] = useState({
        password: '',
        confirmPassword: '',
    });

    const [loading, setLoading] = useState(false);

    const changeHandler = (e) => {
        setValue({ ...value, [e.target.name]: e.target.value });
        validator.showMessages();
    };

    const [validator] = React.useState(new SimpleReactValidator({
        className: 'errorMessage'
    }));

    const submitForm = async (e) => {
        e.preventDefault();
        if (validator.allValid()) {
            console.log('props', props);
            setLoading(true);
            setValue({
                password: '',
                confirmPassword: '',
            });
            validator.hideMessages();
            
            const { password, confirmPassword } = value;

            try {
                if (password !== confirmPassword) {
                    toast.error("Password does not match");
                    return;
                }
                const userData = { id, token, password };
                const result = await authService.users(userData, "change-password");
                if (result && !result.success) {
                    toast.error(result.displayMessage);
                    return;
                }
                toast.success(result.message);
                push('/login');
            } catch (error) {
                toast.error(error.message);
            } finally {
                setLoading(false);
            }
        } else {
            validator.showMessages();
            toast.error('Empty field is not allowed!');
        }
    };
    return (
        <Grid className="loginWrapper">
            {loading && <LoadingOverlay />}
            <Grid className="loginForm">
                <h2>Change Password</h2>
                <p></p>
                <form onSubmit={submitForm}>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <TextField
                                className="inputOutline"
                                fullWidth
                                placeholder="Password"
                                value={value.password}
                                variant="outlined"
                                name="password"
                                type="password"
                                label="New Password"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                onBlur={(e) => changeHandler(e)}
                                onChange={(e) => changeHandler(e)}
                            />
                            {validator.message('password', value.password, 'required')}
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                className="inputOutline"
                                fullWidth
                                placeholder="Confirm Password"
                                value={value.confirmPassword}
                                variant="outlined"
                                name="confirmPassword"
                                type="password"
                                label="Confirm Password"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                onBlur={(e) => changeHandler(e)}
                                onChange={(e) => changeHandler(e)}
                            />
                            {validator.message('Confirm Password', value.confirmPassword, `in:${value.password}`)}
                        </Grid>
                        <Grid item xs={12}>
                            <Grid className="formFooter">
                                <Button fullWidth className="cBtn cBtnLarge cBtnTheme" type="submit">Change Password</Button>
                            </Grid>
                            <p className="noteHelp">Already have an account? <Link to="/login">Return to Sign In</Link></p>
                        </Grid>
                    </Grid>
                </form>
                <div className="shape-img">
                    <i className="fi flaticon-honeycomb"></i>
                </div>
            </Grid>
        </Grid>
    )
};

export default ChangePassword;